// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.get-access-modal {
  opacity: 0;
  visibility: hidden;
}
.get-access-modal.close {
  opacity: 0;
  visibility: hidden;
  animation: fadeOut 0.5s;
  transition: all 0.5s ease-in-out 0s;
}
.get-access-modal.open {
  animation: fadeIn 0.5s;
  visibility: visible;
  opacity: 1;
}

.investor-page-container {
  height: calc(100vh - 60px);
}
.investor-page-container .investor-form {
  display: flex;
  background: white;
  column-gap: 40px;
  height: calc(100vh - 60px);
}
.investor-page-container .investor-form .form {
  animation: fadeIn 1s;
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.investor-page-container .investor-form .form .details {
  width: 100%;
}
.investor-page-container .investor-form .form .details .header {
  font-size: 40px;
  font-weight: 700;
  font-family: "Proxima Nova", sans-serif;
  margin: 0;
  line-height: 60px;
}
.investor-page-container .investor-form .form .details .subheader {
  font-size: 18px;
  font-weight: 600;
  font-family: "Proxima Nova", sans-serif;
  color: var(--secondary-color-5);
  margin: 0;
}
.investor-page-container .investor-form .form .details .get-started > p, .investor-page-container .investor-form .form .details .security > p {
  margin: 0;
  font-size: 24px;
  color: var(--secondary-color-1);
  font-weight: 600;
}
.investor-page-container .investor-form .form .details .get-started > span, .investor-page-container .investor-form .form .details .security > span {
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
  color: var(--secondary-color-5);
}
.investor-page-container .investor-form .form .details .get-started > span > mark, .investor-page-container .investor-form .form .details .security > span > mark {
  color: var(--primary-color-1);
  cursor: pointer;
  font-weight: 600;
  background: none;
}
.investor-page-container .investor-form .form .details .submit-button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 100px;
  border-radius: 10px;
  transition: 0.2s ease-in-out;
  background-color: var(--primary-color-1);
}
.investor-page-container .investor-form .form .details .submit-button:hover {
  opacity: 0.75;
}
.investor-page-container .investor-form .form .details .submit-button.disabled {
  background-color: var(--secondary-color-4);
  cursor: not-allowed;
}
.investor-page-container .investor-form .form .details .submit-button.disabled:hover {
  opacity: 1;
}
.investor-page-container .investor-form .illustration {
  animation: fadeIn 1s;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent linear-gradient(107deg, #FAC91F 0%, #F8A728 100%) 0% 0% no-repeat padding-box;
  position: relative;
  border-radius: 50px;
  width: 100%;
  margin: 30px 0;
}
.investor-page-container .investor-form .illustration .illus {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .investor-page-container .investor-form .illustration {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/InvestorPage/investorPage.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,UAAA;EACA,kBAAA;AADJ;AAEI;EACI,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,mCAAA;AAAR;AAEI;EACI,sBAAA;EACA,mBAAA;EACA,UAAA;AAAR;;AAGA;EACI,0BAAA;AAAJ;AACI;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AACR;AAAQ;EACI,oBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAEZ;AADY;EACI,WAAA;AAGhB;AAFgB;EACI,eAAA;EACA,gBAAA;EACA,uCAAA;EACA,SAAA;EACA,iBAAA;AAIpB;AAFgB;EACI,eAAA;EACA,gBAAA;EACA,uCAAA;EACA,+BAAA;EACA,SAAA;AAIpB;AADoB;EACI,SAAA;EACA,eAAA;EACA,+BAAA;EACA,gBAAA;AAGxB;AADoB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;AAGxB;AAFwB;EACI,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAI5B;AAAgB;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,wCAAA;AAEpB;AADoB;EACI,aAAA;AAGxB;AADoB;EACI,0CAAA;EACA,mBAAA;AAGxB;AAFwB;EACI,UAAA;AAI5B;AAEQ;EACI,oBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qGAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAAZ;AACY;EACI,2BAAA;EACA,4BAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;AAChB;AAGI;EACI;IAAO,UAAA;EAAb;EACM;IAAO,UAAA;EAEb;AACF;;AChHY;EDoHA;IACI,aAAA;EAAd;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.get-access-modal {\n    opacity: 0;\n    visibility: hidden;\n    &.close {\n        opacity: 0;\n        visibility: hidden;\n        animation: fadeOut .5s;\n        transition: all 0.5s ease-in-out 0s;\n    }\n    &.open {\n        animation: fadeIn .5s;\n        visibility: visible;\n        opacity: 1;\n    }\n}\n.investor-page-container {\n    height: calc(100vh - 60px);\n    .investor-form {\n        display: flex;\n        background: white;\n        column-gap: 40px;\n        height: calc(100vh - 60px);\n        .form {\n            animation: fadeIn 1s;\n            flex: 1;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            width: 100%;\n            .details {\n                width: 100%;\n                .header {\n                    font-size: 40px;\n                    font-weight: 700;\n                    font-family: 'Proxima Nova', sans-serif;\n                    margin: 0;\n                    line-height: 60px; \n                }\n                .subheader {\n                    font-size: 18px;\n                    font-weight: 600;\n                    font-family: 'Proxima Nova', sans-serif;\n                    color: var(--secondary-color-5);\n                    margin: 0;\n                }\n                .get-started, .security {\n                    > p {\n                        margin: 0;\n                        font-size: 24px;\n                        color: var(--secondary-color-1);\n                        font-weight: 600;\n                    }\n                    > span {\n                        font-size: 18px;\n                        font-weight: 400;\n                        line-height: 30px;\n                        color: var(--secondary-color-5);\n                        > mark {\n                            color: var(--primary-color-1);\n                            cursor: pointer;\n                            font-weight: 600;\n                            background: none;\n                        }\n                    }\n                }\n                .submit-button {\n                    cursor: pointer;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    height: 50px;\n                    width: 100px;\n                    border-radius: 10px;\n                    transition: .2s ease-in-out;\n                    background-color: var(--primary-color-1);\n                    &:hover {\n                        opacity: .75;\n                    }\n                    &.disabled {\n                        background-color: var(--secondary-color-4);\n                        cursor: not-allowed;\n                        &:hover {\n                            opacity: 1;\n                        }\n                    }\n                }\n            }\n        }\n        .illustration {\n            animation: fadeIn 1s;\n            flex: 1;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background: transparent linear-gradient(107deg, #FAC91F 0%, #F8A728 100%) 0% 0% no-repeat padding-box;\n            position: relative;\n            border-radius: 50px;\n            width: 100%;\n            margin: 30px 0;\n            .illus {\n                background-position: center;\n                background-repeat: no-repeat;\n                background-size: 100% 100%;\n                width: 100%;\n                height: 100%;\n            }\n        }\n    }\n    @keyframes fadein {\n        from { opacity: 0; }\n        to   { opacity: 1; }\n    }\n}\n\n@include media(mobile) {\n    .investor-page-container {\n        .investor-form {\n            .illustration {\n                display: none;\n            }\n        }\n\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
